import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { RootState } from 'store';

import { searchAirport } from 'actions/airports';
import AirportsSearch from 'components/AirportsSearch';
import { Airport } from 'models/airport';

interface Props {
  show: boolean;
  placeHolder: string;
  onClose: () => void;
  onChange: (airport?: Airport) => void;
  type: string;
  zIndex?: number;
}

const AirportsSearchContainer = (props: Props) => {
  const dispatch = useDispatch();
  const airportsState = useSelector((state: RootState) => state.airports);

  const handleSearchChange = _.debounce((value: string) => {
    if (value && value.length > 2) {
      dispatch(searchAirport(value, props.type ?? ''));
    }
  }, 250);

  return <AirportsSearch {...props} {...airportsState} minLengthForSearch={2} onSearchChange={handleSearchChange} />;
};

export default AirportsSearchContainer;
